import React from 'react';
import { Globe2 } from 'lucide-react';
import LiveListingsPanel from './LiveListingsPanel';

export default function LiveListings() {
  return (
    <div className="p-6 md:p-8 max-w-[1400px] mx-auto" data-testid="live-listings-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-11 h-11 rounded-2xl bg-[#679286]/10 grid place-items-center">
          <Globe2 size={20} className="text-[#679286]"/>
        </div>
        <div>
          <h1 className="font-serif text-3xl">Live Listings</h1>
          <p className="text-sm text-slate-500">Real-time Bayut inventory · Dubai · refreshed every 6h · click any card to open the source</p>
        </div>
      </div>
      <LiveListingsPanel/>
    </div>
  );
}
